import { useIsAdmin } from "component/admin";
import { FlowBox, HorizBox, PadBox } from "component/basics";
import { ConversationScreen } from "component/screen";
import { CTAButton } from "component/button";
import { topicTable } from "feature/teaser/topic-photo-teaser";
import { TeaserScreen } from "system/teaser";
import { useCollection, useDatastore, useInstanceKey, useStructureKey } from "util/datastore";
import { Banner } from "component/banner";
import { questionTable } from 'feature/teaser/editorial-question';
import { Heading } from "component/text";
import { useServersideConstructor } from "component/constructor";
import { colorSurfaceInfo } from "component/color";
import { ArticleConfig } from "structure/article";
import { Feature } from "util/stdtypes";

export const OnlyAdminButtonTeaserFeature : Feature<ArticleConfig, {}> = {
    name: 'Admin Teaser',
    key: 'teaserOnlyAdminButton',
    dev: false,
    subscreens: {
        adminLinks: OnlyAdminScreen
    },
    config: {
        teaser: OnlyAdminTeaser
    },
};

export function OnlyAdminTeaser(){
    const datastore = useDatastore()
    const instanceKey = useInstanceKey();
    const structureKey = useStructureKey();
    const isAdmin = useIsAdmin()

    const questions = useCollection(questionTable);
    const topics = useCollection(topicTable)
    if(!isAdmin) return null

    const contentAssigned = questions.filter(q=>!q.deleted).length > 0 ||topics.filter(t=>!t.deleted).length > 0;

    return (
      <TeaserScreen>
        <Banner color={colorSurfaceInfo}>
        {!contentAssigned && <Heading label="No discussion assigned"/>}
          <HorizBox>
            <CTAButton
              label="Open admin screen"
              onPress={() =>
                datastore.gotoInstanceScreen({
                  structureKey,
                  instanceKey,
                  screenKey: "adminLinks",
                  params: {},
                })
              }
            />
          </HorizBox>
        </Banner>
      </TeaserScreen>
    );
}

function OnlyAdminScreen(){
    return <ConversationScreen>
        <AdminTeaserAction/>
    </ConversationScreen>
}

function AdminTeaserAction() {
    const instanceKey = useInstanceKey();
    const structureKey = useStructureKey();
    const datastore = useDatastore();
    useServersideConstructor();
    return <PadBox top={10}>
        <FlowBox rowGap={10} columnGap={10}>
            <CTAButton type='secondary' label='Create a topic'
                onPress={() => datastore.gotoInstanceScreen({ structureKey: 'admin', instanceKey: 'one', screenKey: 'createTopic', params: {} })} />
            <CTAButton type='secondary' label='Assign thread'
                onPress={() => datastore.gotoInstanceScreen({ structureKey, instanceKey, screenKey: 'admin', params: {} })} />
            <CTAButton type='secondary' label='Configure Teaser Features (admin)' 
                onPress={() => datastore.gotoInstanceScreen({structureKey, instanceKey, screenKey: 'features', params: {}})} />
        </FlowBox>
    </PadBox>
}